import tinycolor from "tinycolor2";
import { createMuiTheme } from "@material-ui/core";
import "../App.css";

const primary = "#008AB8";
const secondary = "#BC1C3F";
const warning = "#DBA324";
const error = "#BC1C3F";
const success = "#7FA546";
const info = "#3A88E1";
const gray = "#F9F9FB";
const inputGray = "#F4F4F4";
const white = "#FFFFFF";

const onGoing = "#056B69";

const lightenRate = 7.5;
const darkenRate = 15;

const mainBoxShadow = "0px 3px 30px rgba(0, 0, 0, 0.078)";
const buttonBoxShadow = "3px 6px 15px rgba(0, 138, 184, 0.212)";

// Typography Theming
const font = "'Source Sans Pro', sans-serif";
const fontBold = 700;
const textColor = {
  primary: "#4A4A4A",
  secondary: "#6E6E6E",
  hint: "#B9B9B9",
};
const fontSize = {
  h1Size: "1.7rem",
  h2Size: "1.6rem",
  h3Size: "1.4rem",
  h4Size: "1.3rem",
  h5Size: "1.2rem",
  h6Size: "1.1rem",
  standard: "1rem",
  minus1: "0.9rem",
};

const theme = createMuiTheme({
  palette: {
    primary: {
      main: primary,
      light: tinycolor(primary).lighten(lightenRate).toHexString(),
      dark: tinycolor(primary).darken(darkenRate).toHexString(),
    },
    secondary: {
      main: secondary,
      onGoing: onGoing,
      light: tinycolor(secondary).lighten(lightenRate).toHexString(),
      dark: tinycolor(secondary).darken(darkenRate).toHexString(),
      contrastText: "#FFFFFF",
    },
    warning: {
      main: warning,
      light: tinycolor(warning).lighten(lightenRate).toHexString(),
      dark: tinycolor(warning).darken(darkenRate).toHexString(),
    },
    error: {
      main: error,
      light: tinycolor(error).lighten(lightenRate).toHexString(),
      dark: tinycolor(error).darken(darkenRate).toHexString(),
    },
    success: {
      main: success,
      light: tinycolor(success).lighten(lightenRate).toHexString(),
      dark: tinycolor(success).darken(darkenRate).toHexString(),
    },
    info: {
      main: info,
      light: tinycolor(info).lighten(lightenRate).toHexString(),
      dark: tinycolor(info).darken(darkenRate).toHexString(),
    },
    text: {
      primary: textColor.primary,
      secondary: textColor.secondary,
      hint: textColor.hint,
    },
    background: {
      gray: gray,
      white: white,
      inputGray: inputGray,
    },
    boxShadow: {
      main: mainBoxShadow,
      button: buttonBoxShadow,
    },
  },
  margin: {
    mTop5: 5,
    mTop10: 10,
    mTop15: 15,
    mTop20: 20,
    mBottom5: 5,
    mBottom10: 10,
    mBottom15: 15,
    mBottom20: 20,
  },
  overrides: {
    MuiSvgIcon: {
      root: {
        // color: primary,
      },
    },
    MuiTypography: {
      h1: {
        fontFamily: font,
        fontWeight: fontBold,
        fontSize: fontSize.h1Size,
        color: textColor.primary,
      },
      h2: {
        fontFamily: font,
        fontWeight: fontBold,
        fontSize: fontSize.h2Size,
        color: textColor.primary,
      },
      h3: {
        fontFamily: font,
        fontWeight: fontBold,
        color: textColor.secondary,
        fontSize: fontSize.h3Size,
      },
      h4: {
        fontFamily: font,
        fontWeight: fontBold,
        color: textColor.secondary,
        fontSize: fontSize.h4Size,
      },
      h5: {
        fontFamily: font,
        fontWeight: fontBold,
        color: textColor.secondary,
        fontSize: fontSize.h5Size,
      },
      h6: {
        fontFamily: font,
        fontWeight: fontBold,
        color: textColor.primary,
        fontSize: fontSize.h6Size,
      },
      subtitle1: {
        fontSize: fontSize.minus1,
        fontWeight: fontBold,
        color: textColor.secondary,
      },
      subtitle2: {
        fontSize: fontSize.minus1,
        color: textColor.secondary,
      },
      body1: {
        fontFamily: font,
      },
      body2: {
        fontFamily: font,
      },
    },
  },
});

export default theme;
